import { Platform } from 'react-native'

interface IShadowProps {
    elevation: number
    color: string
    offsetHeight: number
    offsetWidth: number
    opacity: number
    radius: number
    rgba: string
}

export const shadow = (props: IShadowProps) => {
    return Platform.select({
        android: {
            elevation: props.elevation,
        },
        ios: {
            shadowColor: props.color,
            shadowOffset: {
                height: props.offsetHeight,
                width: props.offsetWidth,
            },
            shadowOpacity: props.opacity,
            shadowRadius: props.radius,
        },
        web: {
            boxShadow: `${props.offsetWidth}px ${props.offsetHeight}px ${props.radius}px ${props.rgba}`,
        },
    })
}
